module.exports = __webpack_public_path__ + "10_mustache_grey.5593f9da.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/10_mustache_grey.png
// module id = XwbS
// module chunks = 0